import { default as domainTimeSheet } from './schedule/services' 

export default { 
	domainTimeSheet
}
